import * as yup from "yup";

const createDailySheetReportSchema = yup.object({
  clinic: yup.string().required(),
  date: yup.date().required(),
});

export type DailySheetReportBase = yup.InferType<
  typeof createDailySheetReportSchema
>;

export default createDailySheetReportSchema;
